export default __webpack_public_path__ + "static/media/img4.31be73f0.svg";